import { render, staticRenderFns } from "./BcQuestionField.vue?vue&type=template&id=80f63ff8"
import script from "./BcQuestionField.vue?vue&type=script&lang=js"
export * from "./BcQuestionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports